module.exports = __webpack_public_path__ + "media/images/general/brands/visa-dc3fef2da89bf8bd3d2fe51c71c8a21b.png";